<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách mã giao dịch</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button @click="handleImportFile" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-upload"></i> Tải lên file
        </button>
        <button
          @click="downloadTemplate"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('SCON_RECEIPT_BANK_TRANSACTION_UPLOAD')"
        >
          <i class="bx bx-download"></i> Tải file mẫu
        </button>
      </div>
      <input
        type="file"
        ref="fileInput"
        @change="onFileChange"
        accept=".xlsx, .xls"
        style="display: none"
      />
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian giao dịch
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.transactionCode"
              class="form-control"
              placeholder="Mã giao dịch"
            />
          </div>
          <div class="form-group">
            <input class="form-control" v-model.trim="search.content" placeholder="Nội dung CK" />
          </div>
          <div class="form-group">
            <input
              class="form-control"
              v-model.trim="search.minAmount"
              placeholder="Số tiền từ"
              type="number"
              min="0"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control"
              v-model.trim="search.maxAmount"
              placeholder="Số tiền đến"
              type="number"
              min="0"
            />
          </div>
          <div class="form-group">
            <input
              class="form-control"
              v-model.trim="search.textSearch"
              placeholder="Tìm kiếm tổng hợp"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
            </Select2>
          </div>

          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>

      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng giao dịch</b>: {{ pagination.total }}</span>
            <b-table
              class="mt-1"
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTransaction"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(transactionCode)="data">
                {{ data.item.transactionCode }}
              </template>
              <template #cell(amount)="data">
                {{ data.item.amount | transformMoney }}
              </template>
              <template #cell(content)="data">
                {{ data.item.content }}
              </template>
              <template #cell(transactionTime)="data">
                {{ data.item.transactionTime }}
              </template>
              <template #cell(remainingAmount)="data">
                {{ data.item.remainingAmount | transformMoney }}
              </template>
              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="[data.item.status ? data.item.status.toLowerCase() : '']"
                >
                  {{ data.item.status | mapTextStatus(optionStatusText) }}
                </span>
              </template>
              <template #cell(isLocked)="data">
                <span class="badge" :class="[data.item.isLocked ? 'locked' : 'unlocked']">
                  {{ data.item.isLocked ? 'Đã khóa' : 'Chưa khóa' }}
                </span>
              </template>
              <!-- <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="viewDetail(data.item.id)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item v-if="!data.item.isLocked && dataPermission.includes('TRANSACTION_EDIT')" @click="editTransaction(data.item)">Sửa</b-dropdown-item>
                  <b-dropdown-item v-if="!data.item.isLocked && dataPermission.includes('TRANSACTION_LOCK')" @click="lockTransaction(data.item.id)">Khóa</b-dropdown-item>
                  <b-dropdown-item v-if="data.item.isLocked && dataPermission.includes('TRANSACTION_UNLOCK')" @click="unlockTransaction(data.item.id)">Mở khóa</b-dropdown-item>
                </b-dropdown>
              </template> -->
            </b-table>
          </div>
        </div>
      </div>

      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <b-modal v-model="showImportResultModal" centered size="md" hide-footer no-close-on-backdrop>
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center w-100">
          <h5 class="mb-0 flex-grow-1">
            {{ importSuccess ? 'Import thành công' : 'Kết quả import' }}
          </h5>
          <b-button size="sm" variant="outline-secondary" class="btn-close" @click="close()">
            <i class="bx bx-x" style="font-size: 25px"></i>
          </b-button>
        </div>
      </template>

      <div class="px-3 py-2">
        <!-- Trạng thái thành công -->
        <div v-if="importSuccess" class="text-center py-4">
          <div class="mb-3">
            <div class="success-icon-wrapper d-flex justify-content-center">
              <i class="bx bx-check-circle text-success"></i>
            </div>
          </div>
          <h6 class="text-success mb-0">{{ importResultMessage }}</h6>
        </div>

        <!-- Trạng thái có lỗi -->
        <div v-else>
          <div class="text-center mb-4">
            <div class="warning-icon-wrapper mb-3 d-flex justify-content-center">
              <i class="bx bx-error-circle text-warning"></i>
            </div>
            <h6 class="mb-0">{{ importResultMessage }}</h6>
          </div>

          <!-- Thống kê chi tiết -->
          <div v-if="importResultData" class="stats-container mb-4">
            <div class="row text-center g-3">
              <div class="col-4">
                <div class="stat-item">
                  <div class="stat-number text-primary">{{ importResultData.totalRows }}</div>
                  <div class="stat-label">Tổng</div>
                </div>
              </div>
              <div class="col-4">
                <div class="stat-item">
                  <div class="stat-number text-success">{{ importResultData.successRows }}</div>
                  <div class="stat-label">Thành công</div>
                </div>
              </div>
              <div class="col-4">
                <div class="stat-item">
                  <div class="stat-number text-danger">{{ importResultData.errorRows }}</div>
                  <div class="stat-label">Thất bại</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Nút hành động -->
        <div class="action-buttons d-flex gap-2 justify-content-end">
          <b-button variant="outline-secondary" @click="closeImportModal"> Đóng </b-button>

          <b-button
            v-if="!importSuccess && importResultData && importResultData.errorRows > 0"
            variant="danger"
            @click="downloadErrorFile"
            :disabled="downloadingError"
            class="d-flex align-items-center"
          >
            <i class="bx bx-download me-1"></i>
            {{ downloadingError ? 'Đang tải...' : 'Tải file lỗi' }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { TransactionService } from '@/services/transaction.service'
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import cloneDeep from 'lodash/cloneDeep'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'transactionCode', label: 'Mã giao dịch' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'content', label: 'Nội dung CK' },
    { key: 'transactionTime', label: 'Thời gian GD' },
    { key: 'remainingAmount', label: 'Số tiền chưa gắn phiếu thu' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'isLocked', label: 'Khóa/Mở' },
    // { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
  ]

  export default {
    components: {
      DateRangePicker,
    },
    data() {
      return {
        Config,
        showLoading: false,
        loading: false,
        search: {
          limit: 20,
          page: 1,
          transactionCode: '',
          content: '',
          minAmount: '',
          maxAmount: '',
          startDate: null,
          endDate: null,
          status: '',
          textSearch: '',
        },
        pagination: {
          total: 0,
        },
        dataTransaction: [],
        filterTable: fieldsTable,
        fieldsTable,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        optionStatus: [
          { id: '', text: 'Tất cả' },
          { id: 'UNUSED', text: 'Chưa sử dụng' },
          { id: 'PARTIAL_USED', text: 'Sử dụng một phần' },
          { id: 'FULLY_USED', text: 'Đã sử dụng hết' },
        ],
        optionStatusText: [
          { id: 'UNUSED', text: 'Chưa sử dụng' },
          { id: 'PARTIAL_USED', text: 'Sử dụng một phần' },
          { id: 'FULLY_USED', text: 'Đã sử dụng hết' },
        ],
        showImportResultModal: false,
        importSuccess: false,
        importResultMessage: '',
        importResultData: null,
        downloadingError: false,
      }
    },
    mixins: [prepareQueryParamsMixin],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      transfromDate() {
        this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          transactionCode: '',
          content: '',
          minAmount: '',
          maxAmount: '',
          startDate: null,
          endDate: null,
          status: '',
          textSearch: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          const params = cloneDeep(this.search)

          // Chuyển đổi minAmount và maxAmount sang number nếu có giá trị
          if (params.minAmount) {
            params.minAmount = params.minAmount.toString()
          }
          if (params.maxAmount) {
            params.maxAmount = params.maxAmount.toString()
          }

          // Loại bỏ các tham số rỗng
          for (const key in params) {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
              delete params[key]
            }
          }

          const data = await TransactionService.listTransaction(params)
          if (data.success) {
            this.dataTransaction = data.data || []
            this.pagination.total = data.totalPage.total
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      viewDetail(id) {
        window.open(`/transaction-detail/${id}`, '_blank')
      },
      editTransaction(item) {
        // Logic chỉnh sửa giao dịch
        this.$router.push(`/transaction-edit/${item.id}`)
      },
      async lockTransaction(id) {
        try {
          const confirm = await this.confirmMx('Bạn có chắc chắn muốn khóa giao dịch này?')
          if (confirm) {
            this.showLoading = true
            const data = await TransactionService.lockTransaction(id)
            if (data.success) {
              this.showSuccessMx('Khóa giao dịch thành công')
              await this.fetchData()
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
          this.showFailMx('Có lỗi xảy ra')
        } finally {
          this.showLoading = false
        }
      },
      async unlockTransaction(id) {
        try {
          const confirm = await this.confirmMx('Bạn có chắc chắn muốn mở khóa giao dịch này?')
          if (confirm) {
            this.showLoading = true
            const data = await TransactionService.unlockTransaction(id)
            if (data.success) {
              this.showSuccessMx('Mở khóa giao dịch thành công')
              await this.fetchData()
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
          this.showFailMx('Có lỗi xảy ra')
        } finally {
          this.showLoading = false
        }
      },
      handleImportFile() {
        this.$refs.fileInput.click()
      },
      async onFileChange(event) {
        const file = event.target.files[0]
        if (!file) return

        // Kiểm tra kiểu file
        const fileType = file.name.split('.').pop().toLowerCase()
        if (fileType !== 'xlsx' && fileType !== 'xls') {
          this.msgNoti = 'Vui lòng chọn file Excel (.xlsx, .xls)'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.notiModal = true
          this.$refs.fileInput.value = ''
          return
        }

        // Upload file và xử lý
        await this.importFileExcel(file)

        // Reset input file để có thể chọn lại file cũ
        this.$refs.fileInput.value = ''
      },
      async importFileExcel(file) {
        try {
          this.showLoading = true

          const formData = new FormData()
          formData.append('file', file)

          const response = await TransactionService.importFileExcel(formData)

          this.showLoading = false

          // Xử lý kết quả import
          this.importSuccess =
            response.code === 1000 &&
            (!response.data?.errorRows ||
              response.data?.errorRows === 0 ||
              response.data?.successRows > 0)
          this.importResultData = response.data

          if (this.importSuccess) {
            this.importResultMessage = 'Import dữ liệu thành công'
            await this.fetchData() // Cập nhật lại dữ liệu
          } else {
            this.importResultMessage = response.message || 'Import dữ liệu có lỗi'
          }

          this.showImportResultModal = true
        } catch (error) {
          console.error('Error importing file:', error)
          this.showLoading = false

          this.importSuccess = false
          this.importResultMessage = error.message || 'Có lỗi xảy ra khi import file'
          this.importResultData = null
          this.showImportResultModal = true
        }
      },
      async downloadErrorFile() {
        if (!this.importResultData || !this.importResultData.errorCode) {
          return
        }

        try {
          this.downloadingError = true

          // Gọi API tải file thất bại với errorCode
          await TransactionService.downloadErrorFile({
            reportCode: this.importResultData.errorCode,
          })
        } catch (error) {
          // Có thể hiển thị thông báo lỗi
          this.showFailMx(error.message || 'Có lỗi xảy ra khi tải file thất bại')
        } finally {
          this.downloadingError = false
        }
      },
      closeImportModal() {
        this.showImportResultModal = false
        this.importResultData = null
      },

      async downloadTemplate() {
        try {
          this.showLoading = true
          await TransactionService.downloadFileTemplate()
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }

  .badge.used {
    background-color: #28a745;
    color: white;
  }

  .badge.unused {
    background-color: #6c757d;
    color: white;
  }

  .badge.partial_used {
    background-color: #ffc107;
    color: black;
  }

  .badge.locked {
    background-color: #dc3545;
    color: white;
  }

  .badge.unlocked {
    background-color: #28a745;
    color: white;
  }

  .success-icon-wrapper i,
  .warning-icon-wrapper i {
    font-size: 64px;
  }

  .stats-container {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #e9ecef;
  }

  .stat-item {
    padding: 8px;
  }

  .stat-number {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
  }

  .stat-label {
    font-size: 14px;
    color: #6c757d;
    font-weight: 500;
  }

  .action-buttons {
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
  }

  .btn-close {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: black;
  }

  .btn-close:hover {
    // background-color: white;
  }

  /* Gap utility cho Bootstrap cũ */
  .gap-2 > * + * {
    margin-left: 8px;
  }

  .g-3 > * {
    padding: 6px;
  }

  .me-1 {
    margin-right: 4px;
  }
</style>
